module.exports = __webpack_public_path__ + "static/img/Anna.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/christmasPC-2019/Anna.png
// module id = X0va
// module chunks = 1